export default {
  components: {
    VueRecaptcha: () => import(/* webpackChunkName: "recaptcha" */ 'vue-recaptcha')
  },

  computed: {
    recaptchaSitekey() {
      return LaraVue.recaptcha;
    }
  },

  methods: {
    requestRecaptchaToken() {
      this.$refs.recaptcha.reset()
      this.$refs.recaptcha.execute()
    }
  }
}
